// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K_kzm1 {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--spacing-3);
  min-height: 0;
  width: 100%;
}

.zG7Ol2 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
}

.ytoHCJ {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.x26oiP {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  padding-top: var(--spacing-3);
}

.xeJKaf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.Jq_t8N {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.oz0QkO {
  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.yrJYKd {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 var(--spacing-1-5);
  background-color: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
}

.yrJYKd:focus-within {
  border-color: var(--stroke-primary-medium);
}

.D_SXGJ {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.w0zst7 {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.w0zst7::placeholder {
  color: var(--text-neutral-stronger);
}

.NxA6eZ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: var(--spacing-0-5);
  border: none;
  background: none;
  border-radius: var(--radius-s);
  cursor: pointer;
}

.NxA6eZ:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 1px;
}

.KiwYjH {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

.Z90kUR {
  display: flex;
  flex-direction: column;
  padding: 0 var(--spacing-3);
}

.B8RBQC {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.m1cyVj {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3);
  width: 100%;
  min-height: 0;
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  text-align: center;
}

.pDpGnq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--inline-error-background);
}

.nzzIUV {
  width: 16px;
  height: 16px;
}

.ix54TO {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  width: 270px;
  max-width: 100%;
  color: var(--text-neutral-dark);
}

.PWC4X2 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.k72mrj {
  margin: 0;
  max-width: 280px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.UAAXyk {
  display: flex;
  flex: 0 0 88px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: var(--spacing-3);
  background-color: var(--surface-neutral-white);
}

.m402RE {
  min-width: 100px;
}

@media (max-width: 768px) {
  .K_kzm1 {
    gap: var(--spacing-2);
  }

  .xeJKaf {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1-5);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/CardTrackingListPage/CardTrackingListPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-height: 0;\n  width: 100%;\n}\n\n.pageTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.listCard {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.contentSection {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  padding-top: var(--spacing-3);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.searchWrapper {\n  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.searchField {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  padding: 0 var(--spacing-1-5);\n  background-color: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n}\n\n.searchField:focus-within {\n  border-color: var(--stroke-primary-medium);\n}\n\n.searchIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.searchInput {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-stronger);\n}\n\n.searchClear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: var(--spacing-0-5);\n  border: none;\n  background: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n}\n\n.searchClear:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 1px;\n}\n\n.listArea {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  padding: 0 var(--spacing-3);\n}\n\n.loading {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: center;\n  min-height: 0;\n}\n\n.emptySearch {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-height: 0;\n  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  text-align: center;\n}\n\n.emptyIconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--inline-error-background);\n}\n\n.emptyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.emptyTextBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 270px;\n  max-width: 100%;\n  color: var(--text-neutral-dark);\n}\n\n.emptyTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.emptyBody {\n  margin: 0;\n  max-width: 280px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.footer {\n  display: flex;\n  flex: 0 0 88px;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  padding: var(--spacing-3);\n  background-color: var(--surface-neutral-white);\n}\n\n.footerButton {\n  min-width: 100px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    gap: var(--spacing-2);\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `K_kzm1`,
	"pageTitle": `zG7Ol2`,
	"listCard": `ytoHCJ`,
	"contentSection": `x26oiP`,
	"header": `xeJKaf`,
	"title": `Jq_t8N`,
	"searchWrapper": `oz0QkO`,
	"searchField": `yrJYKd`,
	"searchIcon": `D_SXGJ`,
	"searchInput": `w0zst7`,
	"searchClear": `NxA6eZ`,
	"listArea": `KiwYjH`,
	"list": `Z90kUR`,
	"loading": `B8RBQC`,
	"emptySearch": `m1cyVj`,
	"emptyIconContainer": `pDpGnq`,
	"emptyIcon": `nzzIUV`,
	"emptyTextBlock": `ix54TO`,
	"emptyTitle": `PWC4X2`,
	"emptyBody": `k72mrj`,
	"footer": `UAAXyk`,
	"footerButton": `m402RE`
};
module.exports = ___CSS_LOADER_EXPORT___;
